var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.1648 0C14.003 0 15.5 1.52268 15.5 3.3934L15.5 7.11423C15.5 8.98114 14.0075 10.5 12.1723 10.5L3.83525 10.5C1.99625 10.5 0.5 8.97732 0.5 7.10584L0.5 3.38653C0.5 1.51886 1.9925 0 3.82775 0L4.53275 0L12.1648 0Z",
    fill: "#999FA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40896 14.8369L10.5907 12.7025C10.8157 12.4819 10.8157 12.1269 10.5892 11.9071C10.3627 11.6879 9.99746 11.6887 9.77246 11.9085L8.57771 13.078V11.9567L8.57771 5.664C8.57771 5.35356 8.31896 5.10156 8.00021 5.10156C7.68071 5.10156 7.42271 5.35356 7.42271 5.664L7.42271 13.078L6.22796 11.9085C6.00296 11.6887 5.63771 11.6879 5.41121 11.9071C5.29796 12.0174 5.24096 12.1613 5.24096 12.3059C5.24096 12.449 5.29796 12.5929 5.40971 12.7025L7.59071 14.8369C7.69946 14.9428 7.84646 15.0027 8.00021 15.0027C8.15321 15.0027 8.30021 14.9428 8.40896 14.8369Z",
    fill: "#999FA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.051997994f1eaf79773b6fb40a221939.svg";
export { ForwardRef as ReactComponent };